module.exports = __webpack_public_path__ + "img/arrow-right.736b8d3f.svg";